import axios from "axios";
import { roleManagemenUrl } from "../../config";

const role_baseUrl = roleManagemenUrl.uri;
const token = localStorage.getItem("token");
const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

const headers = {
  Authorization: formattedToken,
  "Content-Type": "application/json",
};
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  return {
    "Authorization": formattedToken,
    "Content-Type": "application/json",
  };
};

// De-duplicate identical in-flight GraphQL queries to prevent double-hits.
const inFlightGraphQLRequests = new Map();

const normalizeQueryForKey = (query) =>
  String(query || "")
    .replace(/\s+/g, " ")
    .trim();

const buildQueryRequestKey = (query, baseUrl) => {
  const token = localStorage.getItem("token") || "";
  return `${baseUrl || ""}::${token}::${normalizeQueryForKey(query)}`;
};

// Usage
export async function graphqlQuery(query, base_url, options = {}) {
  const { bypassDedupe = false } = options;
  const requestKey = buildQueryRequestKey(query, base_url);

  if (!bypassDedupe && inFlightGraphQLRequests.has(requestKey)) {
    return inFlightGraphQLRequests.get(requestKey);
  }

  const requestPromise = (async () => {
    try {
      console.log("Executing GraphQL Query:", query);
      const headers = getAuthHeaders();
      const postData = {
        query,
      };

      const response = await axios.post(base_url, postData, { headers });

      const dataObject = Object.values(response.data.data)[0];
      return dataObject;
    } catch (error) {
      const partialData = error.response?.data?.data;
      const partialValue = partialData
        ? Object.values(partialData).find((value) => value !== null && value !== undefined)
        : null;

      if (partialValue !== null && partialValue !== undefined) {
        console.warn(
          "GraphQL Query returned errors with partial data:",
          error.response?.data?.errors || error.message
        );
        return partialValue;
      }

      console.error("GraphQL Query Failed:", error.response?.data || error.message);
      throw error;
    } finally {
      if (!bypassDedupe) {
        inFlightGraphQLRequests.delete(requestKey);
      }
    }
  })();

  if (!bypassDedupe) {
    inFlightGraphQLRequests.set(requestKey, requestPromise);
  }

  return requestPromise;
}

export async function graphqlQueryWithVar(query, base_url, variables = {}) {
  try {
    console.log("Executing GraphQL Query:", query);
    console.log("With Variables:", variables);

    const headers = getAuthHeaders();

    const postData = {
      query,
      variables, // ✅ Include the variables here
    };

    const response = await axios.post(base_url, postData, { headers });

    // Extract the first field of the data object (common pattern in your code)
    const dataObject = Object.values(response.data.data)[0];
    return dataObject;
  } catch (error) {
    console.error("GraphQL Query Failed:", error.response?.data || error.message);
    throw error;
  }
}


export async function fetchAllData(query) {
  try {
    const data = await graphqlQuery(query);
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export function generateMutation(
  mutationName,
  inputObjectName,
  inputFields,
  InputObject
) {
  let mutation = `mutation ${mutationName} {`;
  mutation += `${inputObjectName}(`;
  mutation += `${InputObject}: {`;
  const inputEntries = Object.entries(inputFields);
  inputEntries.forEach(([key, value], index) => {
    mutation += `${key}: ${JSON.stringify(value)}`;

    if (index < inputEntries.length - 1) {
      mutation += ", ";
    }
  });
  mutation += `}`;
  mutation += `) {
    id
    ${Object.keys(inputFields).join("\n")} 
  }
}`;
  return mutation;
}

export async function graphqlMutation(mutation, base_url) {
  try {
    const headers = getAuthHeaders();
    const postData = {
      query: mutation,
    };
    const response = await axios.post(base_url, postData, { headers });

    return response.data.data;
  } catch (error) {
    throw error;
  }
}

export async function graphqlQueryEngine(query, base_url) {
  try {
    const headers = getAuthHeaders();
    const postData = {
      query,
    };
    // export function generateBulkMutation(operationName, mutationFields, dataArray) {
    //   let mutation = `mutation {
    //     ${operationName}(
    //       ${mutationFields}: [`;

    //   // Iterate over the data array to construct mutation entries
    //   dataArray.forEach((data, index) => {
    //     mutation += `{
    //       ${Object.entries(data)
    //         .map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
    //         .join("\n")}
    //     }`;

    //     // Add comma if not the last entry
    //     if (index < dataArray.length - 1) {
    //       mutation += ",";
    //     }
    //   });

    //   // Close the mutation string
    //   mutation += `]
    //   ) {
    //     ${Object.keys(dataArray[0]).join("\n")}
    //   }
    // }`;

    //   return mutation;
    // }

    const response = await axios.post(base_url, postData, { headers });

    return response.data.data;
  } catch (error) {
    console.error("Error executing GraphQL query:", error);
    throw error;
  }
}
export function generateQuery(queryName, modelName, inputFields = {}, returnFields = []) {
  let query = `query { ${queryName}`;

  // Handle input fields (if any)
  if (Object.keys(inputFields).length > 0) {
    query += `(`;
    if (modelName) {
      query += `${modelName}: {`;
    }

    const inputEntries = Object.entries(inputFields);
    inputEntries.forEach(([key, value], index) => {
      query += `${key}: ${JSON.stringify(value)}`;
      if (index < inputEntries.length - 1) query += ", ";
    });

    if (modelName) {
      query += `}`;
    }
    query += `)`;
  }

  // Add return fields
  if (returnFields && returnFields.length > 0) {
    query += ` {\n  ${returnFields.join("\n  ")}\n}`;
  }

  query += ` }`;

  return query;
}

export async function fetchDataEngine(
  queryName,
  modelName,
  inputFields,
  returnFields,
  baseurl
) {
  try {
    const query = generateQuery(
      queryName,
      modelName,
      inputFields,
      returnFields
    );
    const data = await graphqlQuery(query, baseurl);
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export function generateCustomQuery(
  queryName,
  subQueryName,
  inputFields,
  returnFields
) {
  let query = `query ${queryName} `;

  query = `{ ${subQueryName}(`;

  if (Object.keys(inputFields).length > 0) {
    const inputEntries = Object.entries(inputFields);
    inputEntries.forEach(([key, value], index) => {
      query += `${key}: ${JSON.stringify(value)}`;
      if (index < inputEntries.length - 1) {
        query += ", ";
      }
    });
  }
  query += `)`;

  const returnFieldStrings = returnFields.join("\n");
  query += ` { ${returnFieldStrings} } }`;

  return query;
}

export async function fetchDataEngineCustomized(
  queryName,
  subQueryName,
  inputFields,
  returnFields,
  baseurl
) {
  try {
    const query = generateCustomQuery(
      queryName,
      subQueryName,
      inputFields,
      returnFields,
      baseurl
    );
    const data = await graphqlQuery(query, baseurl);
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function generateAndExecuteBulkMutation(
  operationName,
  mutationFields,
  dataArray,
  base_url
) {
  try {
    const headers = getAuthHeaders();
    // Generate the mutation string
    let mutation = `mutation {
      ${operationName}(
        ${mutationFields}: [`;

    // Iterate over the data array to construct mutation entries
    dataArray.forEach((data, index) => {
      mutation += `{
        ${Object.entries(data)
          .map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
          .join("\n")}
      }`;

      // Add comma if not the last entry
      if (index < dataArray.length - 1) {
        mutation += ",";
      }
    });

    // Close the mutation string
    mutation += `]
      ) {
        ${Object.keys(dataArray[0]).join("\n")}
      }
    }`;

    const postData = { query: mutation };
    const response = await axios.post(base_url, postData, { headers });

    return response.data.data;
  } catch (error) {
    throw error;
  }
}
export async function ExecuteBulkMutationForRights(
  operationName,
  mutationFields,
  dataArray,
  base_url
) {
  try {
    const headers = getAuthHeaders();
    // Generate the mutation string
    let mutation = `mutation {
      ${operationName}(
        ${mutationFields}: [`;

    // Iterate over the data array to construct mutation entries
    dataArray.forEach((data, index) => {
      mutation += `{
        ${Object.entries(data)
          .filter(([key]) => key !== "subRights")
          .map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
          .join("\n")}`;

      // Add subRights if they exist
      if (data.subRights && data.subRights.length > 0) {
        mutation += `,
        subRights: [
          ${data.subRights
            .map(
              (subRight) => `{
              ${Object.entries(subRight)
                  .map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
                  .join("\n")}
            }`
            )
            .join(",")}
        ]`;
      }

      mutation += `}`;

      // Add comma if not the last entry
      if (index < dataArray.length - 1) {
        mutation += ",";
      }
    });

    // Close the mutation string
    mutation += `]
      ) {`;

    // Add the fields to be returned in the response
    const fieldsToReturn = Object.keys(dataArray[0])
      .filter((key) => key !== "subRights")
      .join("\n");

    mutation += `${fieldsToReturn}`;

    // Check if there are subRights to include in the response
    if (dataArray[0].subRights && dataArray[0].subRights.length > 0) {
      mutation += `
        subRights {
          ${Object.keys(dataArray[0].subRights[0]).join("\n")}
        }`;
    }

    // Close the mutation string
    mutation += `
      }
    }`;

    const postData = { query: mutation };
    const response = await axios.post(base_url, postData, { headers });

    return response.data.data;
  } catch (error) {
    throw error;
  }
}

export const createCaseDynamic = async (newCase, base_url) => {
  const mutation = `
    mutation CreateCaseDynamic($newCase: CaseDynamicInput!) {
      createCaseDynamic(newCase: $newCase) {
        id
      }
    }
  `;
const headers = getAuthHeaders();
  const variables = { newCase };

  try {
    const response = await axios.post(
      base_url,
      { query: mutation, variables },
      {
        headers
      }
    );

    if (response.data.errors) {
      console.error("GraphQL Errors:", response.data.errors);
      throw new Error(response.data.errors[0].message);
    }

    return response.data.data.createCaseDynamic;
  } catch (error) {
    console.error("Error creating case:", error);
    throw error;
  }
};


export async function generateAndExecuteMutation(
  inputObjectName,
  inputFields,
  InputObject,
  base_url
) {
  try {
    const headers = getAuthHeaders();
    let mutation = `mutation {`;

   
    if (inputObjectName === "createCreditNotesLine" && Array.isArray(inputFields)) {
      inputFields = inputFields[0];
    }

    // 💡 Helper function to format object fields (remains unchanged)
   const formatObjectFields = (obj) => {
  return Object.entries(obj)
    .map(([key, value]) => {
      let formattedValue;

      if (value === null) {
        formattedValue = "null";
      } else if (Array.isArray(value)) {
        formattedValue = `[${value.join(", ")}]`;
      } else if (typeof value === "string") {
        formattedValue = JSON.stringify(value);
      } else {
        formattedValue = value;
      }

      return `${key}: ${formattedValue}`;
    })
    .join(", ");
};

    
    let formattedInput = "";

    if (Array.isArray(inputFields)) {
      const arrayItems = inputFields.map((obj) => `{ ${formatObjectFields(obj)} }`);
      formattedInput = `[${arrayItems.join(", ")}]`;
    } else {
      formattedInput = `{ ${formatObjectFields(inputFields)} }`;
    }

    
    if (InputObject) {
      // Case: named input object (e.g., approveModel: {...})
      mutation += `${inputObjectName}(${InputObject}: ${formattedInput}`;
    } else {
      // Case: direct args (e.g., id: 4, isActive: true)
      if (formattedInput.startsWith("{") && formattedInput.endsWith("}")) {
        formattedInput = formattedInput.slice(1, -1); // remove { and }
      }
      mutation += `${inputObjectName}(${formattedInput}`;
    }
    
    
    if (
      inputObjectName.toLowerCase().includes("activate") ||
      inputObjectName.toLowerCase().includes("deactivate")
    ) {
      mutation += `) }`; 
    } else if (
      inputObjectName === "createEmailMessage" ||
      inputObjectName === "createMessage"
    ) {
      mutation += `) { messageId } }`;
    } else if (inputObjectName === "approveRejectFeeNotes") {
      mutation += `) { approvedBy statusId feeNoteId result errorMessage   } }`;
    } else if (inputObjectName === "approveRejectPaymentVoucher") {
      mutation += `) { approvedBy paymentVoucherId } }`;
    } else if (inputObjectName === "approveRejectProformaFeeNotesQuotations") {
      mutation += `) { approvedBy statusId id } }`;
    } 
 else if (inputObjectName === "sendFeeNoteForApproval") {
      mutation += `) { clientTypeId clientId id } }`;
    }
 else if (inputObjectName === "aprroveRejectImprestSurrender") {
      mutation += `) { surrenderId approvedBy status approverComments declinedReason } }`;

    }
else if (inputObjectName === "approveDeclineLeaveApplication") {
      mutation += `) { id } }`;
    }
 else if (inputObjectName === "approveRejectImprest") {
  mutation += `) { id approvedBy status } }`; 
 }

else if (inputObjectName === "createPayrollRun") {
      mutation += `) { companyId
        periodStart
        periodEnd
        payDate
        runType
        createdBy } }`;

    }
 else if (inputObjectName === "approvePayrollRun") {
      mutation += `) { payrollRunId approvedBy } }`;
    }
else if (inputObjectName === "postPayrollRun") {
      mutation += `) { payrollRunId postedBy } }`;
    }
else if (inputObjectName === "closePayrollRun") {
      mutation += `) { payrollRunId closedBy } }`;
    }
else if (inputObjectName === "disburseApprovedStaffClaim") {
      mutation += `) { id
        disbursedBy
        isdisbursed
        currencyId
        exchangeRate
        paymentReference
        disbursementAccountType
        disbursementBankAccountId} }`;

    }else if (inputObjectName === "approveRejectPurchaseInvoice") {
      mutation += `) { approvedBy purchaseInvoiceId } }`;
//     } else if (inputObjectName === "createFixedAssetType") {
//        mutation += `) { typeId } }`;
//     } else if (inputObjectName === "createFixedAsset") {
//        mutation += `) { assetId } }`;
    }
else if (inputObjectName === "createImprestSurrenderFromImprest") {
       mutation += `) { applicationId } }`;
    } else {
      mutation += `) { id } }`;
    }

    // ✅ Execute the mutation (remains unchanged)
    const postData = { query: mutation };
    const response = await axios.post(base_url, postData, { headers });
if (response.data.errors) {
      // GraphQL can return errors alongside data (partial success / field-level auth warnings).
      // Only treat it as a hard failure when the primary operation returned no data at all.
      const hasData =
        response.data.data &&
        Object.values(response.data.data).some((v) => v !== null && v !== undefined);

      if (!hasData) {
        const errorMessage =
          response.data.errors[0]?.message || "An unexpected GraphQL error occurred.";
        throw new Error(errorMessage);
      }

      // Mutation succeeded – log the non-blocking server warnings for debugging
      console.warn(
        "GraphQL non-blocking warnings:",
        response.data.errors.map((e) => `${e.message} @ ${(e.path || []).join(".")}`).join(" | ")
      );
    }

    return response.data.data;
  }catch (error) {
    console.error("GraphQL mutation generation error:", error);

    // Handle HTTP errors (e.g., 500)
    if (error.response) {
      // HTTP error (e.g., 500 Internal Server Error)
      const errorMessage =
        error.response.data?.errors?.[0]?.message ||
        error.response.data?.message ||
        `Request failed with status code ${error.response.status}`;
      throw new Error(errorMessage);
    } else if (error.request) {
      // No response received (e.g., network error)
      throw new Error("No response received from the server. Please check your network connection.");
    } else {
      // Other errors (e.g., mutation syntax error)
      throw new Error(error.message || "Failed to execute mutation. Please try again.");
    }
  }
}

export async function MutationWithArrayInput(
  inputObjectName,
  inputFields,
  InputObject,
  base_url,
  returnFields = null
) {
  try {
    const headers = getAuthHeaders();
    let mutation = `mutation {`;

    if (InputObject) {
      mutation += `${inputObjectName}(${InputObject}: {`;
    } else {
      mutation += `${inputObjectName}(`;
    }

    const formatField = (key, value) => {
      if (Array.isArray(value)) {
        return `${key}: [${value
          .map(
            (item) =>
              `{ ${Object.entries(item)
                .map(([k, v]) => `${k}: ${JSON.stringify(v)}`)
                .join(", ")} }`
          )
          .join(", ")}]`;
      } else if (typeof value === "object" && value !== null) {
        return `${key}: { ${Object.entries(value)
          .map(([k, v]) => `${k}: ${JSON.stringify(v)}`)
          .join(", ")} }`;
      } else {
        return `${key}: ${JSON.stringify(value)}`;
      }
    };

    const inputEntries = Object.entries(inputFields);
    inputEntries.forEach(([key, value], index) => {
      mutation += formatField(key, value);
      if (index < inputEntries.length - 1) {
        mutation += ", ";
      }
    });

    if (InputObject) {
      mutation += `}`;
    }
    
    const selection = Array.isArray(returnFields) && returnFields.length > 0
      ? returnFields.join("\n")
      : "id";

    mutation += `) { ${selection} } }`;

    const postData = { query: mutation };
    const response = await axios.post(base_url, postData, { headers });

    return response.data.data;
  } catch (error) {
    throw error;
  }
}

export async function uploadDocument(action, file, dataObject, base_url) {
  if (!file) throw new Error("No file provided for upload.");

  const formData = new FormData();
  if (dataObject.logoUpload && dataObject.logoUpload === true) {
    formData.append("logo", file);
  }
  else {
    formData.append("file", file);
    if (dataObject && dataObject.caseId) {
      formData.append("CaseId", dataObject.caseId);
    } else {
      throw new Error("CaseId is missing.");
    }
  }


  try {
    const token = localStorage.getItem("token");
    const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

    const response = await axios.post(base_url, formData, {
      headers: {
        Authorization: formattedToken,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error uploading the document:", error);
    throw error;
  }
}

export async function GetRoleRightsByRoleId(roleId) {
  try {
    const headers = getAuthHeaders();
    const postData = {
      query: `
    {
      moduleRightsByRoleId(roleId: ${roleId})
    }
        `,
    };
    const response = await axios.post(role_baseUrl, postData, { headers });
    return response.data.data.moduleRightsByRoleId;
  } catch (error) {
    let error_messages = error.response.data.errors;
    throw error;
  }
}

export async function generateAndExecuteBulkMutationForCases(
  operationName,
  mutationFields,
  dataArray,
  base_url,
  caseId
) {
  try {
    const headers = getAuthHeaders();
    // Generate the mutation string
    let mutation = `mutation {
      ${operationName}(
        caseId:${caseId}
        ${mutationFields}: [`;

    // Iterate over the data array to construct mutation entries
    dataArray.forEach((data, index) => {
      mutation += `{
        ${Object.entries(data)
          .map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
          .join("\n")}
      }`;

      // Add comma if not the last entry
      if (index < dataArray.length - 1) {
        mutation += ",";
      }
    });

    // Close the mutation string
    mutation += `]
      ) {
        ${Object.keys(dataArray[0]).join("\n")}
      }
    }`;

    const postData = { query: mutation };
    const response = await axios.post(base_url, postData, { headers });
    return response.data.data;
  } catch (error) {
    throw error;
  }
}

export const submitFileInstruction = async (payload) => {
  return fetchDataEngine("/file-instructions", payload); 
};
